import React from "react";
import "./Card.css";

export default function Cards(props) {
  const { image, name, description, link} = props;

  return (
    <div className="card__container">
      <div className="image__container">
        <img src={image} alt=""></img>
      </div>
      <div className="card__content">
        <h5 className="name">{name}</h5>
        <br/>
        <p className="position">
          {description}
        </p>
      </div>
      <div className="view-project">
          <button><a href={link}>View project</a></button>
      </div>
    </div>
  );
}
